import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { CampaignVideo } from './components/CampaignVideo';
import { About } from './components/About';
import { Quote } from './components/Quote';
import { GetInvolved } from './components/GetInvolved';
import { PeoplePowered } from './components/PeoplePowered';
import { Footer } from './components/Footer';
import { DistrictPage } from './pages/DistrictPage';
import { AboutPage } from './pages/AboutPage';
import { GetInvolvedPage } from './pages/GetInvolvedPage';
import { MediaPage } from './pages/MediaPage';
function HomePage() {
  return <div className="min-h-screen bg-warmgray font-sans text-navy selection:bg-red selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <CampaignVideo data-id="element-4" />
        <About data-id="element-5" />
        <Quote data-id="element-6" />
        <PeoplePowered data-id="element-7" />
        <GetInvolved data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-10">
      <Routes data-id="element-11">
        <Route path="/" element={<HomePage data-id="element-13" />} data-id="element-12" />
        <Route path="/district" element={<DistrictPage data-id="element-15" />} data-id="element-14" />
        <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
        <Route path="/volunteer" element={<GetInvolvedPage data-id="element-19" />} data-id="element-18" />
        <Route path="/media" element={<MediaPage data-id="element-21" />} data-id="element-20" />
      </Routes>
    </BrowserRouter>;
}